function throttleOrDebounce(type) {
  return function (delay, callback, isEndCallback = false) {
    let timeoutID;
    let cancelled = false; // 判断是否消除的依据
    let lastExec = 0; // 设置为0就是为了让节流第一次执行

    // 取消下一个执行函数
    function clearExistingTimeout() {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
    }

    // 全局清除
    function cancel() {
      clearExistingTimeout();
      cancelled = true;
    }

    function wrapper() {
      if (cancelled) return;
      let arguments_;
      // eslint-disable-next-line prefer-rest-params,prefer-const
      arguments_ = arguments;
      const self = this;
      const elapsed = Date.now() - lastExec; // 过去的时间
      // 执行
      function exec() {
        lastExec = Date.now();
        callback.apply(self, arguments_);
      }

      clearExistingTimeout();
      if (type === 'throttle' && elapsed > delay) {
        exec();
      } else {
        // 节流
        if (type === 'throttle') {
          if (isEndCallback) {
            timeoutID = setTimeout(exec, delay - elapsed);
          }
        }
        // 防抖
        if (type === 'debounce') {
          lastExec = Date.now();
          timeoutID = setTimeout(exec, delay);
        }
      }
    }

    wrapper.cancel = cancel; //返回包装器函数。 消除的方法
    return wrapper;
  };
}

const debounce = throttleOrDebounce('debounce');
const throttle = throttleOrDebounce('throttle');

export { debounce, throttle };
